import UpArrow from "../../Assets/Icons/up-arrow.png";
import DownArrow from "../../Assets/Icons/arrow-down-sign-to-navigate.png";
import { useEffect, useState } from "react";

type ScorePickerSize = "Small" | "Large";

const ScorePicker: React.FC<{
  start?: number;
  onChange: (n: number) => void;
  size?: ScorePickerSize;
}> = ({ onChange, size = "Large", start = 0 }) => {
  const [number, setNumber] = useState(start);
  const iconSize = size === "Large" ? 20 : 10;
  const numberHeight = size === "Large" ? 80 : 40;

  useEffect(() => {
    onChange(number);
  }, [number]);
  return (
    <div
      style={{
        display: "flex",
        flexFlow: "column",
        textAlign: "center",
        fontWeight: "bolder",
      }}
    >
      <img
        src={UpArrow}
        style={{
          width: iconSize,
          textAlign: "center",
          margin: "auto auto",
          cursor: "pointer",
        }}
        onClick={() => {
          setNumber(number === 0 ? 1 : number + 1);
        }}
      />
      <h1
        style={{
          fontSize: numberHeight,
          textAlign: "center",
          fontWeight: "bolder",
        }}
      >
        {number}
      </h1>
      <img
        src={DownArrow}
        style={{
          width: iconSize,
          textAlign: "center",
          margin: "auto auto",
          cursor: "pointer",
        }}
        onClick={() => {
          setNumber(number === 0 ? 0 : number - 1);
        }}
      />
    </div>
  );
};

export { ScorePicker };
